<template>
    <div class="m-grid m-grid--hor m-grid--root m-page">
        <div
            class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
            id="m_login"
            style="background-image: url(/assets/img/login/login.jpg)"
        >
            <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
                <div class="m-login__container">
                    <div class="m-login__logo">
                        <custom-img height="140" width="280" :src="logoLogin" :lazy="false"></custom-img>
                    </div>
                    <div class="m-login__signin">
                        <form class="m-login__form m-form" @submit.prevent="validLogin">
                            <div
                                v-if="resp.STATUS == 'ERROR'"
                                class="alert-danger alert alert-dismissible"
                                role="alert"
                            >
                                <button
                                    type="button"
                                    class="close"
                                    @click="resp.STATUS = ''"
                                ></button>
                                <span>{{ resp.RESPONSE }}</span>
                            </div>
                            <div
                                class="form-group m-form__group"
                                :class="{ 'has-danger': errors.has('user') }"
                            >
                                <input
                                    class="form-control m-input"
                                    type="text"
                                    :placeholder="$t('general.user')"
                                    :aria-label="$t('general.user')"
                                    name="user"
                                    autocomplete="username"
                                    v-model.lazy="inputsData.user"
                                    v-validate="'required|min:4|max:40|'"
                                />
                                <form-error
                                    :attribute_name="'user'"
                                    :errors_form="errors"
                                ></form-error>
                            </div>
                            <div
                                class="form-group m-form__group"
                                :class="{ 'has-danger': errors.has('password') }"
                            >
                                <input
                                    class="form-control m-input m-login__form-input--last"
                                    type="password"
                                    :placeholder="$t('general.password')"
                                    :aria-label="$t('general.password')"
                                    name="password"
                                    autocomplete="current-password"
                                    v-model.lazy="inputsData.password"
                                    v-validate="'required|min:4|max:40|'"
                                />
                                <form-error
                                    :attribute_name="'password'"
                                    :errors_form="errors"
                                ></form-error>
                            </div>
                            <div class="m-login__form-action">
                                <button
                                    type="submit"
                                    id="m_login_signin_submit"
                                    class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn"
                                    :disabled="disableForm"
                                    :class="{
                                        'm-login__btn--primary m-loader m-loader--right m-loader--light':
                                            disableForm,
                                    }"
                                >
                                    {{ $t("general.login") }}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="m-login__account">
                        <span class="m-login__account-msg">{{
                            $t("general.copyrightLogin", { year: new Date().getFullYear() })
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customImg from "../Element/custom-img";
    import FormError from "../FormError";

    export default {
        name: "Login",
        components: {
            FormError,
            customImg,
        },
        mounted() {},
        data: function () {
            let user = "";
            if (this.$session.get("user")) {
                user = this.$session.get("user");
            }
            return {
                inputsData: {
                    user: user,
                    password: "",
                },
                resp: {
                    STATUS: "",
                },
                disableForm: false,
            };
        },
        methods: {
            validLogin: function () {
                if (!this.disableForm) {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.$session.destroy();
                            this.disableForm = true;
                            this.axios
                                .post("Login", this.inputsData)
                                .then((response) => {
                                    this.resp = response.data;
                                    this.disableForm = false;

                                    if (response.data.STATUS == "OK") {
                                        this.$session.clear();
                                        this.$session.set("TOKEN", response.data.TOKEN);
                                        let user = response.data.RESPONSE;
                                        for (let prop in user) {
                                            this.$session.set(prop, user[prop]);
                                        }
                                        this.$router.push("/dashboard");
                                    }
                                });
                        }
                    });
                }
            },
        },
        computed: {
            logoLogin() {
                let baseLoginUrl = this.baseUrlAxios() + "logoLogin/";

                let entity = this.$route.params.entity;
                let entityId = this.$route.params.entityId;

                if (entity && entityId) {
                    let logo = `${entity}/${entityId}`;
                    this.$session.set("logo", logo);
                    return `${baseLoginUrl}${logo}`;
                }
                if (this.$session.get("logo")) {
                    //Cambiamos la url para que concuerde con la de la sesión
                    const logoPath = this.$session.get("logo");
                    const [entity, entityId] = logoPath.split("/");

                    this.$router.replace({
                        name: "Login",
                        params: {
                            entity,
                            entityId,
                        },
                    });

                    return `${baseLoginUrl}${this.$session.get("logo")}`;
                }

                return `${baseLoginUrl}`;
            },
        },
    };
</script>
<style scoped>
#m_login {
    min-height: 100vh;
    background-position: center;
    background-size: cover;
}

/* Accessibility: improve placeholder contrast ratio (WCAG AA 4.5:1) */
.m-login__form .form-control::placeholder {
    color: #595464;
    opacity: 1;
}
.m-login__form .form-control:-ms-input-placeholder {
    color: #595464;
}
</style>
